import React, { useCallback, useContext, useState } from "react";
import i18next from "i18next";
import { Grid } from "@mui/material";
import { RuleActionParameterNames, RuleActionParameterOptions, RulesContext } from "services/common/RulesUtils";
import RuleSelectInput from "components/rules/RuleSelectInput";
import { isSealedDossier } from "services/common/Constants";
import { useFormContext } from "react-hook-form";


const DossierTypeChangeActionParams = ({ fieldName, readOnly = false }) => {

  const mappedOptions = RuleActionParameterOptions?.map(({ value, label }) => ({
    value,
    label: i18next.t(`rules.configuration.ruleActions.fields.parameters.dossierTypeChangeOptions.options.${label}`)
  }));
  const [options, setOptions] = useState(mappedOptions);

  const {
    dossierTypes,
  } = useContext(RulesContext);

  const formMethods = useFormContext();
  const {
    setValue
  } = formMethods;

  const mappedDossierTypes = dossierTypes?.map(({ code, label }) => ({
    value: code !== "null" ? code : 'FREE',
    label
  }));

  const filterOptionsDependingOnDossierType = useCallback((selectedDossierTypeCode) => {
    const dossierType = dossierTypes.filter(dt => dt.code === selectedDossierTypeCode)[0];
    if (selectedDossierTypeCode === 'FREE' || dossierType?.isLocked) {
      setValue(`${fieldName}.${RuleActionParameterNames.DOSSIER_TYPE_CHANGE_OPTION}`, mappedOptions[2].value)
      setOptions([mappedOptions[2]]);
    } else {
      setValue(`${fieldName}.${RuleActionParameterNames.DOSSIER_TYPE_CHANGE_OPTION}`, null)
      setOptions(mappedOptions);
    }
    // eslint-disable-next-line
  }, [mappedOptions, dossierTypes]);

  const validateDossierTypeCode = (value) => {
  }

  return (
    <Grid container spacing={2} style={{ alignItems: "center", justifyContent: "center" }}>
      <Grid item xs={12} md={4}>
        <RuleSelectInput
          fieldName={`${fieldName}.${RuleActionParameterNames.DOSSIER_TYPE_CODE}`}
          label={`${i18next.t("rules.configuration.ruleActions.fields.parameters.dossierTypeCode.label")}`}
          placeholder={i18next.t(`rules.configuration.ruleActions.fields.parameters.dossierTypeCode.placeholder`)}
          options={mappedDossierTypes?.filter(
            (dossierType) => 
              !isSealedDossier(dossierType.value)
          )}
          onChange={filterOptionsDependingOnDossierType}
          isRequired
          validate={validateDossierTypeCode}
          labelVariant='chip'
          disabled={readOnly}
        />
      </Grid >

      <Grid item xs={12} md={4}>
        <RuleSelectInput
          fieldName={`${fieldName}.${RuleActionParameterNames.DOSSIER_TYPE_CHANGE_OPTION}`}
          label={`${i18next.t("rules.configuration.ruleActions.fields.parameters.dossierTypeChangeOptions.label")}`}
          placeholder={i18next.t(`rules.configuration.ruleActions.fields.parameters.dossierTypeChangeOptions.placeholder`)}
          options={options}
          onChange={() => { }}
          isRequired
          labelVariant='chip'
          disabled={readOnly}
        />
      </Grid>
    </Grid >
  );
}

export default DossierTypeChangeActionParams;
